<div soho-searchfield-wrapper>
    <label class="audible" for="{{testVersion1 ? 'banner-searchfield' : 'search-menu-searchfield'}}">{{ 'Search' | translate }}</label>
    <ng-container *ngIf="!menuV3">
        <input #searchField
            soho-toolbar-searchfield
            id="{{testVersion1 ? 'banner-searchfield' : 'search-menu-searchfield'}}"
            data-automation-id="lm-appmenu-search-menu-searchfield"
            placeholder="{{ 'Search' | translate }}"
            [autocomplete]="'off'"
            [(ngModel)]="model.searchFieldValue"
            [collapsibleOnMobile]="false"
            [clearable]="true"
            (ngModelChange)="onAutoSearchMenu($event)"
            (keydown.enter)="onFireMenuSearchEvent($event)"
            (cleared)="onFireClearSearchEvent($event)"
        />
    </ng-container>
    <ng-container *ngIf="menuV3">
        <input #searchField
           soho-searchfield
           id="{{'search-menu-searchfield'}}"
           name="module-nav-searchfield"
           placeholder="{{ 'Search' | translate }}"
           data-automation-id="lm-appmenu-search-menu-searchfield"
           [autocomplete]="'off'"
           [(ngModel)]="model.searchFieldValue"
           [ngClass]="{ 'searchfield': true, 'module-nav-search': true } "
           [options]="{ collapsible: false, tabbable: true }"
           (ngModelChange)="onAutoSearchMenu($event)"
           (keydown.enter)="onFireMenuSearchEvent($event)"
        />
    </ng-container>

    <!-- work around for v3 in sohoxi.js

        -- the below code causes search menu to close after clearing --

        checkOutsideClick: function checkOutsideClick(targetEl) {
          if (this.settings.displayMode === 'expanded') {
            var target = targetEl;
            if (target && !$(target).is('.application-menu-trigger') && !this.element[0].contains(target)) {
              this.setDisplayMode(this.isLargerThanBreakpoint() ? 'collapsed' : false);
              this.removeOutsideClickEvent();
            }
          }

          !this.element[0].contains(target) is evaluating to true because the button is removed from the DOM when using *ngIf

          - hiding the button vs removing it from the DOM will prevent this from happening
          - this prevents this.removeOutsideClickEvent(); from firing
          - which is causing the applicaton menu to close after clearing search
    -->
    <button [ngStyle]="{'display': model.searchFieldValue.length > 0 && menuV3 ? 'inline-block': 'none'}"
        (click)="onMenuSearchCleared($event)"
        type="button"
        class="btn-icon hide-focus close"
        tabindex="0"
        focusable="true"
        data-automation-id="lm-appmenu-searchfield-clear-button"
    >
        <svg soho-icon [icon]="'close'"></svg>
    </button>
</div>



